// extracted by mini-css-extract-plugin
export default {"userInfo":"userInfo--fSY81","buttonPadding":"buttonPadding--aKKn1","page":"page--pCF_x","bottomWrapper":"bottomWrapper--EDm5v"};